export default __webpack_public_path__ + "static/media/Remolquede SúperLujo12.d62ff358.png";